"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var article_collection_view_1 = require("@reverbdotcom/commons/dist/components/article_collection_view");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var RelatedArticles = /** @class */ (function (_super) {
    tslib_1.__extends(RelatedArticles, _super);
    function RelatedArticles() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RelatedArticles.prototype.componentDidMount = function () {
        this.trackImpression();
    };
    RelatedArticles.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.articles === prevProps.articles) {
            return;
        }
        this.trackImpression();
    };
    RelatedArticles.prototype.trackImpression = function () {
        if (this.props.articles.length < 2) {
            return;
        }
        tracker_1.trackView({
            componentName: 'RelatedArticleCard',
            type: tracker_1.ARTICLE_TYPE,
            ids: this.props.articles.map(function (article) { return article.id; }),
        });
    };
    RelatedArticles.prototype.render = function () {
        if (this.props.articles.length < 2) {
            return null;
        }
        return (React.createElement(article_collection_view_1.default, { title: this.props.heading, articles: this.props.articles, action: this.props.action }));
    };
    return RelatedArticles;
}(React.Component));
exports.default = RelatedArticles;
//# sourceMappingURL=related_articles.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/shared/related_articles.js
// module id = uNI2
// module chunks = 20 21